import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { config } from 'src/app/environment-config';

const env = config();
@Injectable()
export class MixpanelService {
  // TODO: Refactor initialized into a subject  that emits
  // once initialized, so events and properties created
  // before initialization due to race condition, can be created
  // later, and they're not lost
  private initialized: boolean;

  constructor() {}

  public init(userId: string, userEmail: string): void {
    if (!userId) {
      return;
    }
    const MIXPANEL_API_KEY = env.analytics.mixpanelApiKey;
    mixpanel.init(MIXPANEL_API_KEY);

    const mixpanelUserProps = {
      $email: userEmail,
    };
    mixpanel.identify(userId);
    this.initialized = true;
    this.addUserProps(mixpanelUserProps);
  }

  public track(event: string, action: any = {}): void {
    try {
      this.initialized && mixpanel.track(event, action);
    } catch (err) {
      console.warn('error track: %o', err);
    }
  }

  public addUserProps(props: any = {}): void {
    try {
      this.initialized && mixpanel.people.set(props);
    } catch (err) {
      console.warn('Error addUserProps: %o', err);
    }
  }
}
